module.exports = __webpack_public_path__ + "img/sec5_2_.aa81d432.png";